(function () {
  'use strict';

  var WEBHOOK_URL = 'https://automation.ethicalhq.com/webhook/8a5144e2-20b2-429b-a39a-bbbd58f36353';
  var EMAILABLE_API_KEY = 'live_77cf6e9b8b568e336d63';
  var REDIRECT_URL = '/pages/thank-you-shopify-stores-for-roasters';
  var SUBMITTING_TEXT = 'Submitting\u2026';
  var turnstileWidgetId = null;

  /* =========================
     Init
  ========================== */
  document.addEventListener('DOMContentLoaded', function () {

    /* --- Hash trigger buttons --- */
    var triggers = document.querySelectorAll('a[href^="#getInTouch"]');
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', handleTriggerClick);
    }

    /* --- Modal close button --- */
    var closeBtn = document.getElementById('cn-modal-services-close');
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    /* --- Overlay click to close --- */
    var modal = document.getElementById('cn-modal-services');
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });
    }

    /* --- ESC key --- */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeModal();
    });

    /* --- Form setup --- */
    var form = document.getElementById('shopify-services-form');
    if (!form) return;

    var hasTurnstile = window.turnstile && window.TURNSTILE_SITE_KEY;

    if (hasTurnstile) {
      var container = form.querySelector('.turnstile-container');
      if (container) {
        turnstile.ready(function () {
          turnstileWidgetId = turnstile.render(container, {
            sitekey: window.TURNSTILE_SITE_KEY,
            size: 'invisible',
            execution: 'execute',
            action: 'shopify_roaster_get_in_touch',
            callback: onTurnstileSuccess,
            'error-callback': onTurnstileError
          });
        });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleSubmit();
      }, true);

    } else {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handleDirectSubmit();
      }, true);
    }
  });

  /* =========================
     Hash click → set plan → open modal
  ========================== */
  function handleTriggerClick(e) {
    e.preventDefault();
    var href = this.getAttribute('href');
    var plan = href.replace('#getInTouch', '');
    if (!plan) plan = 'General';
    var planInput = document.getElementById('shopify-plan');
    if (planInput) planInput.value = plan;
    openModal();
  }

  function openModal() {
    var modal = document.getElementById('cn-modal-services');
    if (modal) modal.classList.add('cn-modal--open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    var modal = document.getElementById('cn-modal-services');
    if (modal) modal.classList.remove('cn-modal--open');
    document.body.style.overflow = '';
  }

  /* =========================
     Turnstile path
  ========================== */
  function handleSubmit() {
    var submitBtn = document.getElementById('shopify-services-submit');
    var payload = collectFormData();

    if (!payload.firstName) { showStatus('error', 'First name is required'); return; }
    if (!payload.lastName) { showStatus('error', 'Last name is required'); return; }
    if (!payload.roasteryName) { showStatus('error', 'Roastery name is required'); return; }
    if (!payload.email) { showStatus('error', 'Email address is required'); return; }
    if (!isValidEmailFormat(payload.email)) { showStatus('error', 'Please enter a valid email address'); return; }

    setLoading(submitBtn, true, SUBMITTING_TEXT);

    if (!turnstileWidgetId) {
      showStatus('error', 'Verification unavailable. Please refresh and try again.');
      setLoading(submitBtn, false);
      return;
    }

    turnstile.execute(turnstileWidgetId);
  }

  function onTurnstileSuccess(token) {
    var form = document.getElementById('shopify-services-form');
    if (!form) return;
    var submitBtn = document.getElementById('shopify-services-submit');
    var tokenInput = form.querySelector('[name="turnstile_token"]');
    if (tokenInput) tokenInput.value = token;
    submitForm(token, submitBtn);
  }

  function onTurnstileError() {
    showStatus('error', 'Verification failed. Please try again.');
    var submitBtn = document.getElementById('shopify-services-submit');
    setLoading(submitBtn, false);
  }

  /* =========================
     Direct path (no Turnstile)
  ========================== */
  function handleDirectSubmit() {
    var submitBtn = document.getElementById('shopify-services-submit');
    var payload = collectFormData();

    if (!payload.firstName) { showStatus('error', 'First name is required'); return; }
    if (!payload.lastName) { showStatus('error', 'Last name is required'); return; }
    if (!payload.roasteryName) { showStatus('error', 'Roastery name is required'); return; }
    if (!payload.email) { showStatus('error', 'Email address is required'); return; }
    if (!isValidEmailFormat(payload.email)) { showStatus('error', 'Please enter a valid email address'); return; }

    setLoading(submitBtn, true, SUBMITTING_TEXT);
    submitForm(null, submitBtn);
  }

  /* =========================
     Core submit
  ========================== */
  function submitForm(token, submitBtn) {
    var payload = collectFormData();
    if (token) payload.turnstile_token = token;

    var hutk = getHubspotUTK();
    payload['form-name'] = 'Shopify Store';
    payload.context = {
      pageUri: window.location.href,
      pageName: document.title
    };
    if (hutk) payload.context.hutk = hutk;

    validateWithEmailable(payload.email)
      .then(function (isValid) {
        if (!isValid) throw new Error('Please check your email address and try again.');
        return sendToWebhook(payload);
      })
      .then(function () {
        window.location.href = REDIRECT_URL;
      })
      .catch(function (err) {
        showStatus('error', err.message || 'Something went wrong. Please try again.');
        setLoading(submitBtn, false);
        if (turnstileWidgetId) {
          try { turnstile.reset(turnstileWidgetId); } catch (e) {}
        }
      });
  }

  /* =========================
     Data collection
  ========================== */
  function collectFormData() {
    return {
      firstName: getVal('SS-First-Name'),
      lastName: getVal('SS-Last-Name'),
      roasteryName: getVal('SS-Roastery-Name'),
      phone: getVal('SS-Phone'),
      email: getVal('SS-Email'),
      submissionType: getVal('shopify-plan')
    };
  }

  /* =========================
     Webhook
  ========================== */
  function sendToWebhook(payload) {
    return fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('Submission failed. Please try again.');
    });
  }

  /* =========================
     Emailable
  ========================== */
  function validateWithEmailable(email) {
    if (!EMAILABLE_API_KEY) return Promise.resolve(true);
    return fetch(
      'https://api.emailable.com/v1/verify?email=' + encodeURIComponent(email) + '&api_key=' + EMAILABLE_API_KEY
    ).then(function (res) {
      if (!res.ok) return true;
      return res.json().then(function (data) {
        return data.state !== 'undeliverable';
      });
    }).catch(function () {
      return true;
    });
  }

  /* =========================
     HubSpot UTK
  ========================== */
  function getHubspotUTK() {
    var m = document.cookie.match(/hubspotutk=([^;]+)/);
    return m ? m[1] : '';
  }

  /* =========================
     Helpers
  ========================== */
  function getVal(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  function showStatus(type, message) {
    var el = document.getElementById('shopify-services-form-status');
    if (!el) return;
    el.textContent = message;
    el.className = 'cn-form-status cn-form-status--' + type;
    el.style.display = 'block';
    el.setAttribute('role', 'alert');
  }

  function isValidEmailFormat(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function setLoading(btn, state, text) {
    if (!btn) return;
    if (state) {
      btn.setAttribute('data-original-text', btn.textContent);
      btn.textContent = text || 'Sending\u2026';
      btn.disabled = true;
      btn.style.opacity = '0.6';
      btn.style.pointerEvents = 'none';
    } else {
      btn.textContent = btn.getAttribute('data-original-text') || 'Send';
      btn.disabled = false;
      btn.style.opacity = '1';
      btn.style.pointerEvents = 'auto';
    }
  }

})();
